import React, { useState, useRef } from "react";
import classNames from "classnames";
import { useIntersection } from "helpers/intersectionObserverHelpers";
import { Modal } from "react-bootstrap";

const ImageRenderer = ({ url, thumb = "/media/users/default.jpg", className, onError }) => {
  const imgRef = useRef();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);

  useIntersection(imgRef, () => {
    setIsInView(true);
  });

  const handleOnLoad = () => {
    setIsLoaded(true);
  };

  const [show, setShow] = useState(false);

  return (
    <>
      <div
        className={classNames("image-renderer-container ", className)}
        ref={imgRef}
        onClick={() => setShow(true)}
      >
        {isInView && (
          <>
            <img
              className={classNames("image-renderer", "thumb", { isLoaded: !!isLoaded })}
              src={thumb}
            />
            <img
              className={classNames("image-renderer", { isLoaded: !!isLoaded })}
              src={url}
              onLoad={handleOnLoad}
              onError={onError}
            />
          </>
        )}
      </div>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <img src={url ? url : thumb} className="w-100" style={{ objectFit: "scale-down" }} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImageRenderer;
